import { ClarisApiError } from '../../domain/error';
import {
  IpSettingPostRequestParams,
  IpSettingPutRequestParams,
} from '../../domain/ipSetting/types';
import { LoadingState } from '../../domain/schemas';

// Action Types
const POST_SETTINGS_IP = 'POST_SETTINGS_IP' as const;
const POST_SETTINGS_IP_REQUEST = 'POST_SETTINGS_IP_REQUEST' as const;
const POST_SETTINGS_IP_SUCCESS = 'POST_SETTINGS_IP_SUCCESS' as const;
const POST_SETTINGS_IP_FAILURE = 'POST_SETTINGS_IP_FAILURE' as const;
const PUT_SETTINGS_IP = 'PUT_SETTINGS_IP' as const;
const PUT_SETTINGS_IP_REQUEST = 'PUT_SETTINGS_IP_REQUEST' as const;
const PUT_SETTINGS_IP_SUCCESS = 'PUT_SETTINGS_IP_SUCCESS' as const;
const PUT_SETTINGS_IP_FAILURE = 'PUT_SETTINGS_IP_FAILURE' as const;
const DELETE_SETTINGS_IP = 'DELETE_SETTINGS_IP' as const;
const DELETE_SETTINGS_IP_REQUEST = 'DELETE_SETTINGS_IP_REQUEST' as const;
const DELETE_SETTINGS_IP_SUCCESS = 'DELETE_SETTINGS_IP_SUCCESS' as const;
const DELETE_SETTINGS_IP_FAILURE = 'DELETE_SETTINGS_IP_FAILURE' as const;

export const SettingsIPActionTypes = {
  POST_SETTINGS_IP,
  POST_SETTINGS_IP_REQUEST,
  POST_SETTINGS_IP_SUCCESS,
  POST_SETTINGS_IP_FAILURE,
  PUT_SETTINGS_IP,
  PUT_SETTINGS_IP_REQUEST,
  PUT_SETTINGS_IP_SUCCESS,
  PUT_SETTINGS_IP_FAILURE,
  DELETE_SETTINGS_IP,
  DELETE_SETTINGS_IP_REQUEST,
  DELETE_SETTINGS_IP_SUCCESS,
  DELETE_SETTINGS_IP_FAILURE,
};

// Action Creators
// post時は、新規登録アイテムを全て送信する
function postSettingsIPAction(params: IpSettingPostRequestParams) {
  return {
    type: POST_SETTINGS_IP,
    payload: { params },
  };
}

function postSettingsIPRequestAction() {
  return {
    type: POST_SETTINGS_IP_REQUEST,
  };
}

function postSettingsIPSuccessAction() {
  return {
    type: POST_SETTINGS_IP_SUCCESS,
  };
}

function postSettingsIPFailureAction(error: ClarisApiError) {
  return {
    type: POST_SETTINGS_IP_FAILURE,
    payload: { error },
  };
}

function putSettingsIPAction(params: IpSettingPutRequestParams) {
  return {
    type: PUT_SETTINGS_IP,
    payload: { params },
  };
}

function putSettingsIPRequestAction() {
  return {
    type: PUT_SETTINGS_IP_REQUEST,
  };
}

function putSettingsIPSuccessAction() {
  return {
    type: PUT_SETTINGS_IP_SUCCESS,
  };
}

function putSettingsIPFailureAction(error: ClarisApiError) {
  return {
    type: PUT_SETTINGS_IP_FAILURE,
    payload: { error },
  };
}

function deleteSettingsIPAction(groupIpId: number) {
  return {
    type: DELETE_SETTINGS_IP,
    payload: { groupIpId },
  };
}

function deleteSettingsIPRequestAction() {
  return {
    type: DELETE_SETTINGS_IP_REQUEST,
  };
}

function deleteSettingsIPSuccessAction() {
  return {
    type: DELETE_SETTINGS_IP_SUCCESS,
  };
}

function deleteSettingsIPFailureAction(error: ClarisApiError) {
  return {
    type: DELETE_SETTINGS_IP_FAILURE,
    payload: { error },
  };
}

export const SettingsIPActionCreators = {
  postSettingsIPAction,
  postSettingsIPRequestAction,
  postSettingsIPSuccessAction,
  postSettingsIPFailureAction,
  putSettingsIPAction,
  putSettingsIPRequestAction,
  putSettingsIPSuccessAction,
  putSettingsIPFailureAction,
  deleteSettingsIPAction,
  deleteSettingsIPRequestAction,
  deleteSettingsIPSuccessAction,
  deleteSettingsIPFailureAction,
};

export type PostSettingsIPAction = ReturnType<typeof postSettingsIPAction>;

export type PutSettingsIPAction = ReturnType<typeof putSettingsIPAction>;

export type DeleteSettingsIPAction = ReturnType<typeof deleteSettingsIPAction>;

type SettingsIPAction =
  | PostSettingsIPAction
  | ReturnType<typeof postSettingsIPRequestAction>
  | ReturnType<typeof postSettingsIPSuccessAction>
  | ReturnType<typeof postSettingsIPFailureAction>
  | PutSettingsIPAction
  | ReturnType<typeof putSettingsIPRequestAction>
  | ReturnType<typeof putSettingsIPSuccessAction>
  | ReturnType<typeof putSettingsIPFailureAction>
  | DeleteSettingsIPAction
  | ReturnType<typeof deleteSettingsIPRequestAction>
  | ReturnType<typeof deleteSettingsIPSuccessAction>
  | ReturnType<typeof deleteSettingsIPFailureAction>;

// Selector

/**
 * ローディング状態を取得するセレクタ
 */
export function settingsUsersLoadingStateSelector(rootState: {
  settingsIP: SettingsIPState;
}) {
  return rootState.settingsIP.loadingState;
}

/**
 * エラー情報を取得するセレクタ
 */
export function settingsIPErrorSelector(rootState: {
  settingsIP: SettingsIPState;
}) {
  return rootState.settingsIP.error;
}

// Reducer
type SettingsIPState = {
  loadingState: LoadingState;
  error: ClarisApiError | undefined;
};
const initialState: SettingsIPState = {
  loadingState: 'prepare',
  error: undefined,
};
export function settingsIPReducer(
  state = initialState,
  action: SettingsIPAction
): SettingsIPState {
  switch (action.type) {
    case POST_SETTINGS_IP_REQUEST:
    case PUT_SETTINGS_IP_REQUEST:
    case DELETE_SETTINGS_IP_REQUEST:
      return {
        ...state,
        loadingState: 'loading',
        error: undefined,
      };
    case POST_SETTINGS_IP_SUCCESS:
    case PUT_SETTINGS_IP_SUCCESS:
    case DELETE_SETTINGS_IP_SUCCESS:
      return {
        ...state,
        loadingState: 'loaded',
      };
    case POST_SETTINGS_IP_FAILURE:
    case PUT_SETTINGS_IP_FAILURE:
    case DELETE_SETTINGS_IP_FAILURE:
      return {
        ...state,
        loadingState: 'failed',
        error: action.payload.error,
      };
    default:
      return state;
  }
}
